import type { FaireProductEntity } from "../../entity_types/product";

export const p_3xvnny8hur: FaireProductEntity = {
  token: "p_3xvnny8hur",
  type: "product",
  name: "Colombia - El Ramo - 12oz - Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/3e94614cba0799fc9a14b1efafe7abb4fcbc235fc4a92268e8754cd48ad44b0a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a82f230aed77eb0d4ffee48e7950e4e0c4a1178b7b37f2eb3895d50bb7c2bbae.jpeg",
    "https://cdn.faire.com/fastly/3e2b7343ea56dd3defe2db37011d8920c3051bff967b99069f718df9c4b9d693.jpeg",
    "https://cdn.faire.com/fastly/741487980e7bd67841b43cd8e872f78fa9218391cae2fd4680f6aaad6440976c.jpeg",
    "https://cdn.faire.com/fastly/8b000f4c20983cfd75ada79853e90a366e69491ce7516cac3568fd453853deb3.jpeg"
  ],
  priceDollars: 11.88,
  description: "El Ramo is our project showcasing the impeccable flavor profile of the coffee from Colombia’s towns of Caicedo and Urrao in the department of Antioquia. El Ramo, meaning the bouquet in Spanish, is comprised of seasonally rotating lots from some of our closest and most favorite producers in the region.\n\nThe result is a beautiful offering that is blended to maintain an exceptionally sweet and approachable profile all year round. Notes of vibrant stonefruit, fresh cream and vanilla make for a comforting and warm cup.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Sources: Individual small-scale producers of COOCAFISA\n• Tasting Notes: Peach, Fresh Cream and Vanilla\n• Elevation: 1,900 - 2,100 meters\n• Region: Caicedo, Antioquia, Colombia\n• Variety: Typica, Caturra and Bourbon\n• Process: Wet-Processed\n\n𝐅𝐚𝐫𝐦 𝐑𝐞𝐥𝐚𝐭𝐢𝐨𝐧𝐬𝐡𝐢𝐩\nYes\n\nA perfect fall favorite!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:33.844Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
